import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { loadAddresses } from "./thunks/load-addresses";
import { loadMaxAttempts } from "./thunks/load-max-attempts";
import { loadZones } from "./thunks/load-zones";
import { submitFailedDelivery } from "./thunks/submit-failed-delivery";

const name = "failedDelivery";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitFailedDelivery.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = "";
        state.submitErrorCode = "";
      })
      .addCase(submitFailedDelivery.fulfilled, (state) => {
        state.isSubmitting = false;
      })
      .addCase(submitFailedDelivery.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError = action.error.message ?? "";
        state.submitErrorCode = action.payload ?? "";
      })
      .addCase(loadAddresses.pending, (state) => {
        state.isLoadingAddresses = true;
      })
      .addCase(loadAddresses.fulfilled, (state, action) => {
        state.isLoadingAddresses = false;
        state.addresses = action.payload;
      })
      .addCase(loadAddresses.rejected, (state) => {
        state.isLoadingAddresses = false;
        state.addresses = [];
      })
      .addCase(loadZones.pending, (state) => {
        state.isLoadingZones = true;
      })
      .addCase(loadZones.fulfilled, (state, action) => {
        state.isLoadingZones = false;
        state.zones = action.payload;
      })
      .addCase(loadZones.rejected, (state) => {
        state.isLoadingZones = false;
        state.zones = [];
      })
      // A cap that cannot be read keeps the default: the backend is what
      // enforces it, and leaving the screen without one would hide how many
      // attempts are left.
      .addCase(loadMaxAttempts.fulfilled, (state, action) => {
        state.maxAttempts = action.payload;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
